module.exports = __webpack_public_path__ + "static/img/banner-ojk.d96918ac.png";